// Интерфейс для качества видео
export interface VideoQuality {
  label: string;
  value: number;
  height?: number;
  bitrate?: number;
}

// Расширенный интерфейс для видео, учитывающий HLS-специфичные поля
export interface HlsVideo {
  url: string;
  width?: number;
  height?: number;
  preview_url?: string;
  thumbnailUrl?: string;
  short_video_preview_url?: string;
  fallbackUrl?: string; // Запасной URL, если HLS не поддерживается
  levels?: VideoQuality[]; // Предопределенные уровни качества
}

export interface WidgetOptions {
  productArticle: string;
  baseColor?: string;
  productName?: string;
  clientId: string; // Публичный идентификатор клиента
}

export type Rating = number;

export interface Question {
  id: string;
  author: string;
  comment: string;
  date: string;
  answer?: Answer;
  store?: Store;
  productLink?: string;
}

export interface Photo {
  url: string;
  width: number;
  height: number;
}

export interface Video {
  url: string;
  preview_url?: string;
  short_video_preview_url?: string;
  thumbnailUrl?: string;
  width?: number;
  height?: number;
}

export interface Review extends Question {
  rating: Rating;
  advantages?: string;
  disadvantages?: string;
  recommends?: boolean;
  productName?: string;
  photos?: Photo[];
  videos?: Video[];
}

export interface Answer {
  author: string;
  text: string;
  date: string;
}

export interface ReviewStats {
  averageRating: number;
  totalReviews: number;
  ratingDistribution: Record<Rating, number>;
}

export interface ProductStats {
  widget_stats: Record<string, number>;
  marketplace_stats: Record<string, number>;
  total_stats: Record<string, number>;
  average_rating: number;
}

export enum Store {
  OZON = "ozon",
  YANDEX = "yandex",
  WILDBERRIES = "wildberries",
  SBERMARKET = "sbermarket",
}

import ozonLogo from "@assets/store-logos/ozon.svg";
import yandexLogo from "@assets/store-logos/yandex.svg";
import wildberriesLogo from "@assets/store-logos/wb.svg";
import sbermarketLogo from "@assets/store-logos/sber.svg";

export const storeLogos: Record<Store, string> = {
  [Store.OZON]: ozonLogo,
  [Store.YANDEX]: yandexLogo,
  [Store.WILDBERRIES]: wildberriesLogo,
  [Store.SBERMARKET]: sbermarketLogo,
};
